import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const HoursRangeWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-hours-range",
})`
  display: flex;
  align-items: center;
  margin-inline-start: 30px;
  gap: 8px;
  font-size: 14px;
  white-space: nowrap;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-start: 10px;
    gap: 4px;
    font-size: 13px;
    flex-wrap: wrap;
  }
`;

export const HoursRangeSeparatorStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-hours-range-separator",
})`
  color: ${greyMui._500};
  font-weight: 500;
  padding-inline: 2px;
  user-select: none;
`;

export const HoursRangeDatePreviewStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-hours-range-preview",
})`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-inline-start: 8px;
  color: ${greyMui._600};
  font-size: 13px;

  .dash {
    opacity: 0.7;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

export const HoursNumberFieldStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-hours-number-field",
})`
  display: inline-flex;
  align-items: center;

  .MuiInputBase-root {
    width: 58px;
    padding-inline-end: 0;
  }

  .MuiInputBase-input {
    padding: 4px 0 4px 6px;
    text-align: center;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .hours-number-steppers {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin: 0;
    max-height: none;
    height: 100%;
    padding-inline-end: 2px;

    &.MuiInputAdornment-root {
      margin-inline-start: 0;
    }
  }

  .hours-number-stepper-btn {
    padding: 0;
    width: 22px;
    height: 14px;
    border-radius: 2px;

    .MuiSvgIcon-root {
      font-size: 14px;
    }
  }
`;
